const gcr = {
    _name: 'Kréyòl Giyàn',
    _flag: '🇬🇫',
    // Nav
    'nav.dashboard': 'Tablo a bò',
    'nav.pos': 'Pwen lavant',
    'nav.calcul': 'Kalkil Pri',
    'nav.devis': 'Devi / Fakti',
    'nav.devisDeplacement': 'Devi Déplasman',
    'nav.commandes': 'Kòmand',
    'nav.addDevice': 'Ajouté aparèy',
    'nav.reparations': 'Réparasyon',
    'nav.clients': 'Kliyant',
    'nav.stock': 'Stòk',
    'nav.addStock': 'Ajouté Stòk',
    'nav.etiquettes': 'Étikèt',
    'nav.users': 'Itilizatè',
    'nav.clientPwd': 'Mo d pas Kliyant',
    'nav.boutiqueOrders': 'Kòmand Boutik',
    'nav.caisseHistory': 'Istorik Kès',
    'nav.database': 'Baz done',
    'nav.historique': 'Istorik',
    'nav.paiements': 'Péman an lign',
    'nav.chatClients': 'Chat Kliyant',
    'nav.chat': 'Mésajri',
    'nav.notes': 'Nòt',
    'nav.logout': 'Dékonnèksyon',
    'nav.quit': 'Kité',
    'nav.admin': 'Administrasyon',
    'nav.navigation': 'Navigasyon',
    'nav.b2b': 'Jésyon B2B',
    'nav.b2bPayments': 'Péman B2B',
    'nav.brandsModels': 'Mak & Modèl',
    // Common
    'common.save': 'Anréjistré',
    'common.cancel': 'Anilé',
    'common.delete': 'Siprimé',
    'common.edit': 'Modifyé',
    'common.search': 'Chèché',
    'common.add': 'Ajouté',
    'common.close': 'Fèmé',
    'common.confirm': 'Konfirmé',
    'common.loading': 'Ka chajé...',
    'common.noData': 'Pa gen done',
    'common.actions': 'Aksyon',
    'common.status': 'Stati',
    'common.date': 'Dat',
    'common.total': 'Total',
    'common.print': 'Enprimé',
    'common.yes': 'Wi',
    'common.no': 'Non',
    'common.back': 'Rétouné',
    'common.next': 'Swivan',
    'common.validate': 'Validé',
    'common.ref': 'Référans',
    'common.client': 'Kliyant',
    'common.phone': 'Téléfòn',
    'common.email': 'Imèl',
    'common.price': 'Pri',
    'common.quantity': 'Kantité',
    'common.amount': 'Montan',
    'common.send': 'Voyé',
    'common.download': 'Téléchajé',
    'common.export': 'Èksporté',
    'common.refresh': 'Aktyalizé',
    'common.filter': 'Filtré',
    'common.all': 'Tout',
    'common.name': 'Non',
    'common.address': 'Adrès',
    'common.description': 'Déskripsyon',
    'common.payment': 'Péman',
    'common.paid': 'Péyé',
    'common.pending': 'An atant',
    'common.accepted': 'Aksèpté',
    'common.refused': 'Réfizé',
    // Layout
    'layout.panel': 'Panèl jésyon',
    // POS
    'pos.title': 'Pwen d Vant',
    'pos.scanner': 'Skanè',
    'pos.searchProduct': 'Chèché on pwodwi (réf, non, kòd-bar)...',
    'pos.outOfStock': 'Pa gen stòk',
    'pos.article': 'Artik',
    'pos.unitPrice': 'Pri inité',
    'pos.qty': 'Kté',
    'pos.emptyCart': 'Panyé vid',
    'pos.checkout': 'Ankèsman',
    'pos.clientOptional': 'Kliyant (opsyonèl)',
    'pos.discount': 'Rédisyon',
    'pos.subtotal': 'Sou-total',
    'pos.validateSale': 'Validé lavant',
    'pos.paymentMode': 'Mòd péman',
    'pos.choosePayment': 'Chwazi mòd péman :',
    'pos.cash': 'Lajan kach',
    'pos.card': 'Kat Bankè',
    'pos.mixed': 'Miks',
    'pos.totalToCollect': 'Total pou ankèsé',
    'pos.change': 'Lajan randi',
    'pos.confirmPayment': 'Konfirmé péman',
    'pos.validating': 'Ka validé...',
    'pos.lastTicket': 'Dènié tikè',
    'pos.caisseClosed': 'Kès la fèmé. Ouvè-l dépi Tablo a bò pou fè lavant.',
    'pos.insufficientCash': 'Montan lajan kach pa asé',
    'pos.insufficientCard': 'Montan kat pa asé',
    'pos.mixedMustEqual': 'Péman miks la dwa égal total la',
    'pos.emptyCartAlert': 'Panyé vid',
    'pos.selectPayment': 'Chwazi on mòd péman souplé',
    'pos.saleValidated': 'Lavant validé!',
    'pos.adminOverride': 'Validasyon administratè',
    'pos.outOfStockProduct': 'Pwodwi an ripti',
    'pos.adminId': 'Idantifyan admin',
    'pos.adminCode': 'Kòd admin',
    'pos.manualAdd': 'Ajouté on artik pa dan stòk',
    'pos.designation': 'Dézinyasyon',
    'pos.stockInsufficient': 'Stòk pa asé',
    // Devis
    'devis.title': 'Devi & Fakti',
    'devis.subtitle': 'Dokiman ki sòti dan kalkil pri (ka touné kòmand).',
    'devis.noDoc': 'Pa gen dokiman trouvé',
    'devis.type': 'Tip',
    'devis.convertConfirm': 'Transformé devi-a an kòmand ?',
    'devis.orderCreated': 'Kòmand kréyé',
    'devis.deleteConfirm': 'Siprimé dokiman-a ?',
    'devis.deleted': 'Dokiman siprimé',
    // Devis Déplacement
    'devDep.title': 'Devi Déplasman',
    'devDep.subtitle': 'Jésyon devi pou réparasyon a domisil',
    'devDep.new': 'Nouvo devi',
    'devDep.edit': 'Modifyé devi-a',
    'devDep.clientName': 'Non kliyant',
    'devDep.clientPhone': 'Téléfòn',
    'devDep.clientEmail': 'Imèl',
    'devDep.clientAddress': 'Adrès',
    'devDep.repairDesc': 'Déskripsyon réparasyon',
    'devDep.lines': 'Lign devi-a',
    'devDep.addLine': 'Ajouté',
    'devDep.travelFee': 'Fré déplasman',
    'devDep.sendByEmail': 'Voyé pa imèl',
    'devDep.sending': 'Ka voyé...',
    'devDep.pdfDevis': 'PDF Devi',
    'devDep.pdfBon': 'PDF Bon d kòmand',
    'devDep.pdfFacture': 'PDF Fakti',
    'devDep.searchPlaceholder': 'Chèché pa réf, non, imèl...',
    'devDep.allStatuses': 'Tout stati',
    'devDep.pending': 'An atant',
    'devDep.accepted': 'Aksèpté',
    'devDep.refused': 'Réfizé',
    'devDep.depositPaid': 'Akont vérsé',
    'devDep.fullyPaid': 'Péyé',
    'devDep.stats': 'Statistik',
    'devDep.revenues': 'Réveni',
    'devDep.activity30d': 'Aktivité 30 dènié jou',
    'devDep.remind': 'Rélansé',
    'devDep.remindConfirm': 'Voyé on rapèl ba kliyant ki gen devi an atant dépi plis ki 3 jou ?',
    'devDep.noDevis': 'Pa gen devi kréyé',
    'devDep.noResults': 'Pa gen rézilta',
    'devDep.bon': 'Bon d kòmand',
    'devDep.facture': 'Fakti',
    'devDep.emailSent': 'Imèl voyé a',
    'devDep.reminderSent': 'Rapèl voyé a',
    // Reparations
    'rep.title': 'Réparasyon',
    'rep.search': 'Chèché on réparasyon...',
    'rep.new': 'Nouvo réparasyon',
    'rep.deviceRef': 'Réf. aparèy',
    'rep.brand': 'Mak',
    'rep.model': 'Modèl',
    'rep.problem': 'Pwoblèm',
    'rep.technician': 'Téchnisyen',
    'rep.timeline': 'Kronoloji',
    'rep.manage': 'Jésyon Réparasyon',
    'rep.noRepairs': 'Pa gen réparasyon trouvé',
    'rep.allStatuses': 'Tout stati',
    'rep.imei': 'IMEI / Séri',
    'rep.client': 'Kliyant',
    'rep.phone': 'Tél',
    'rep.date': 'Dat',
    'rep.deposit': 'Akont',
    'rep.printFiche': 'Enprimé fich',
    'rep.printEtiquette': 'Enprimé étikèt',
    'rep.deleteConfirm': 'Siprimé réparasyon-a ?',
    'rep.addDeposit': 'Ajouté akont',
    'rep.depositAmount': 'Montan akont',
    'rep.paymentMode': 'Mòd péman',
    'rep.depositHistory': 'Istorik akont',
    'rep.totalDeposits': 'Total akont',
    'rep.changeStatus': 'Chanjé stati',
    'rep.notes': 'Nòt intèn',
    'rep.sendChat': 'Voyé mésaj',
    'rep.noTimeline': 'Pa gen évènman',
    // Commandes
    'cmd.title': 'Kòmand',
    'cmd.search': 'Chèché on kòmand...',
    'cmd.piece': 'Pyès',
    'cmd.supplier': 'Founisè',
    'cmd.deposit': 'Akont',
    'cmd.remaining': 'Rès a péyé',
    'cmd.manage': 'Jésyon Kòmand',
    'cmd.noOrders': 'Pa gen kòmand trouvé',
    'cmd.allStatuses': 'Tout stati',
    'cmd.ordered': 'Kòmandé',
    'cmd.received': 'Résévwa',
    'cmd.cancelled': 'Anilé',
    'cmd.status': 'Stati',
    'cmd.ref': 'Réf',
    'cmd.addOrder': 'Nouvo kòmand',
    'cmd.editOrder': 'Modifyé kòmand',
    'cmd.deleteConfirm': 'Siprimé kòmand-a ?',
    // Clients
    'clients.title': 'Kliyant',
    'clients.search': 'Chèché on kliyant...',
    'clients.name': 'Non',
    'clients.address': 'Adrès',
    'clients.addClient': 'Nouvo kliyant',
    'clients.manage': 'Jésyon Kliyant',
    'clients.total': 'kliyant an total',
    'clients.add': 'Ajouté',
    'clients.noClients': 'Pa gen kliyant trouvé',
    'clients.type': 'Tip',
    'clients.discount': 'Rédisyon',
    'clients.account': 'Kont',
    'clients.sent': 'Voyé',
    'clients.activeAccount': 'Aktif',
    'clients.noEmail': 'Pa gen imèl',
    'clients.editClient': 'Modifyé kliyant',
    'clients.newClient': 'Nouvo kliyant',
    'clients.company': 'Sosyété',
    'clients.clientType': 'Tip kliyant',
    'clients.individual': 'Patikilié',
    'clients.business': 'Antrépriz',
    'clients.discountPct': 'Rédisyon (%)',
    'clients.deleteConfirm': 'Siprimé kliyant-a ?',
    'clients.page': 'Paj',
    // Stock
    'stock.title': 'Jésyon Stòk',
    'stock.search': 'Chèché on artik...',
    'stock.addArticle': 'Ajouté artik',
    'stock.category': 'Katégori',
    'stock.buyPrice': 'Pri acha',
    'stock.sellPrice': 'Pri lavant',
    'stock.available': 'Disponibl',
    'stock.manage': 'Jésyon Stòk',
    'stock.noItems': 'Pa gen artik trouvé',
    'stock.barcode': 'Kòd-bar',
    'stock.reference': 'Référans',
    'stock.alert': 'Alèrt',
    'stock.lowStockAlert': 'Stòk fèb',
    'stock.addForm': 'Ajouté on artik',
    'stock.editForm': 'Modifyé artik la',
    'stock.deleteConfirm': 'Siprimé artik-a ?',
    // Dashboard
    'dash.title': 'Tablo a bò',
    'dash.openCaisse': 'Ouvè kès la',
    'dash.closeCaisse': 'Fèmé kès la',
    'dash.todaySales': 'Lavant jodi-a',
    'dash.monthSales': 'Lavant mwa-a',
    'dash.activeRepairs': 'Réparasyon aktif',
    'dash.pendingOrders': 'Kòmand an atant',
    'dash.hello': 'Bonjo',
    'dash.loggedAs': 'Konnèkté kon',
    'dash.caisseOpen': 'Kès ouvè',
    'dash.closeCaisseReminder': 'Pa bliyé fèmé kès la',
    'dash.noCaisse': 'Pa gen kès ouvè',
    'dash.openCaisseTitle': 'Ouvè kès la',
    'dash.openTotal': 'Total louvèti',
    'dash.opening': 'Ka ouvè...',
    'dash.open': 'Ouvè',
    'dash.searchPlaceholder': 'Chèché pa référans, kliyant, téléfòn...',
    'dash.noResults': 'Pa gen rézilta trouvé',
    'dash.today': 'Jodi-a',
    'dash.thisMonth': 'Mwa-a',
    'dash.completed': 'Tèminé',
    'dash.repairsSub': 'réparasyon',
    'dash.inProgress': 'An kou',
    'dash.waitingParts': 'ka atann pyès',
    'dash.registeredMonth': 'anréjistré mwa-a',
    'dash.statsTitle': 'Statistik & Analitik',
    'dash.statsDesc': 'Chif afè, réparasyon, B2B, kliyant',
    'dash.brandsModelsLabel': 'Mak & Modèl',
    'dash.brandsModelsDesc': 'Jéré katalòg aparèy',
    'dash.b2bPaymentsLabel': 'Péman B2B',
    'dash.b2bPaymentsDesc': 'Sivi fakti ak péman',
    'dash.stockAlerts': 'Alèrt Stòk',
    'dash.lowStock': 'pwodwi an stòk fèb',
    'dash.outOfStock': 'an ripti d stòk',
    'dash.recentRepairs': 'Dènié réparasyon',
    'dash.noClient': 'San kliyant',
    'dash.unclosedTitle': 'Kès pa fèmé',
    'dash.unclosedNotClosed': 'pa té fèmé',
    'dash.contactAdmin': 'Kontak on administratè pou fèmé-l avan kontinié.',
    'dash.mustClose': 'Ou dwa fèmé-l avan ou pé kontinié travay.',
    'dash.forceClose': 'Fèmti forsé',
    'dash.closing': 'Ka fèmé...',
    'dash.closeNormal': 'Fèmé nòmalman',
    'dash.noCaisseToday': 'Pa gen kès ouvè pou jodi-a.',
    'dash.openQuestion': 'Ou vlé ouvè kès la kounié-a ?',
    'dash.dontOpen': 'Pa ouvè (kontinié)',
    'dash.salesBlocked': 'Lavant ké bloké tan kès la pa ouvè.',
    'dash.calculation': 'Kalkil',
    'dash.repairs': 'Réparasyon',
    'dash.addDevice': 'Ajouté',
    'dash.clients': 'Kliyant',
    'dash.openedBy': 'ouvè pa',
    'dash.unknown': 'pa konnèt',
    'dash.forceCloseConfirm': 'Fèmé d fòs kès la di',
    'dash.errorForceClose': 'Éré lò fèmti forsé',
    'dash.errorOpenCaisse': 'Éré lò louvèti kès la',
    // Login
    'login.title': 'Konnèksyon',
    'login.username': 'Idantifyan',
    'login.password': 'Kòd aksè',
    'login.submit': 'Konnèkté',
    'login.clientAccess': 'Aksè kliyant',
    'login.staffAccess': 'Aksè pèsonèl',
    'login.clientSpace': 'Espas Kliyant',
    'login.businessSpace': 'Espas Antrépriz',
    'login.staffSpace': 'Espas Staf',
    'login.connectYou': 'Konnèkté-ou',
    'login.phoneNumber': 'Niméro téléfòn',
    'login.proEmail': 'Imèl pwofèsyonèl',
    'login.pin': 'Kòd PIN (4 ou 6 chif)',
    'login.pinHint': 'Tapé kòd-ou avèk klavié-a ou padé nimérik la.',
    'login.connecting': 'Ka konnèkté...',
    'login.connect': 'Konnèkté',
    'login.noAccount': 'Pa gen kont ankò ?',
    'login.createAccount': 'Kréyé on kont',
    'login.forgotPwd': 'Mo d pas bliyé ?',
    'login.notRegistered': 'Pa ankò enskri ?',
    'login.businessRegister': 'Enskripsyon antréprize',
    'login.secure': 'Konnèksyon sékirizé',
    'login.caricature': 'Mo kréyé karikatir-mwen',
    'login.backHome': 'Rétouné lakay',
    'login.wrongCredentials': 'Idantifyan pa bon',
    'login.pinError': 'Kòd PIN dwa gen 4 ou 6 chif',
    'login.b2bPassword': 'Mo d pas',
    'login.b2bPlaceholder': 'Mo d pas-ou',
    'login.yourId': 'Idantifyan-ou',
    // Language
    'lang.select': 'Lang',
    // Client Portal
    'client.space': 'Espas Kliyant',
    'client.repairs': 'Réparasyon',
    'client.boutique': 'Boutik',
    'client.orders': 'Kòmand',
    'client.messages': 'Mésaj',
    'client.devis': 'Devi',
    'client.trackRepairs': 'Sivi réparasyon-ou',
    'client.noRepairs': 'Pa gen réparasyon an kou',
    'client.trackOrders': 'Sivi kòmand-ou',
    'client.noOrders': 'Pa gen kòmand an kou',
    'client.shop': 'Boutik an lign',
    'client.noProducts': 'Pa gen pwodwi disponibl',
    'client.addToCart': 'Ajouté dan panyé',
    'client.yourMessages': 'Mésaj-ou',
    'client.noMessages': 'Pa gen mésaj',
    'client.send': 'Voyé',
    'client.brand': 'Mak',
    'client.model': 'Modèl',
    'client.problem': 'Pwoblèm',
    'client.status': 'Stati',
    'client.deposit': 'Akont',
    'client.remaining': 'Rès a péyé',
    'client.total': 'Total',
    'client.timeline': 'Kronoloji',
    'client.noDevis': 'Pa gen devi pou liminman',
    'client.acceptRefuse': 'Aksèpté / Réfizé',
    'client.pay': 'Péyé',
    // Landing
    'landing.mobileRepair': 'Réparasyon mobil an Giyàn',
    'landing.staffSpace': 'ESPAS STAF',
    'landing.staffDesc': 'Aksè ékip técnik',
    'landing.clientSpace': 'ESPAS KLIYANT',
    'landing.clientDesc': 'Sivi réparasyon',
    'landing.businessSpace': 'ESPAS ANTRÉPRIZE',
    'landing.businessDesc': 'Pòtay B2B',
    'landing.contact': 'Kontak',
    'landing.callWhatsapp': 'Aplé & WhatsApp',
    'landing.writeUs': 'Ékri-nou dirèkteman',
    'landing.hours': 'Orè louvèti',
    'landing.legal': 'Enfòmasyon légal',
    'landing.capital': 'o kapital d',
    'landing.headquarters': 'Syèj',
    'landing.allRights': 'Tout drwa rézèrvé',
    'landing.heroSubtitle': 'Spésyalis réparasyon mobil an Giyàn',
    'landing.mondayFriday': 'Lendi - Vandrèdi',
    'landing.saturday': 'Sanmdi',
    'landing.sunday': 'Dimanch',
    'landing.closed': 'Fèmé',
    'landing.companyType': 'Sosyété pa Aksyon Senplifié (SAS)',
    'landing.openMaps': 'Ouvè dan Maps',
    'landing.rcs': 'RCS',
    'landing.siret': 'SIRET',
    'landing.euid': 'EUID',
    'landing.shopAddress': 'Pwen d vant',
    // Devis Accept
    'devisAccept.error': 'Éré',
    'devisAccept.notFound': 'Devi pa trouvé',
    'devisAccept.refused': 'Devi réfizé',
    'devisAccept.refusedMsg': 'Ou réfizé devi-a',
    'devisAccept.thanks': 'Mèsi pou enfòmé nou.',
    'devisAccept.accepted': 'Devi aksèpté !',
    'devisAccept.acceptedMsg': 'Mèsi ou aksèpté devi-a',
    'devisAccept.bonCommande': 'Bon d kòmand',
    'devisAccept.facture': 'Fakti',
    'devisAccept.emailSent': 'On imèl avèk bon d kòmand-ou, kòd validasyon ak idantifyan konnèksyon-ou té voyé.',
    'devisAccept.proceedPayment': 'Alé péyé',
    'devisAccept.paymentMsg': 'Pou finalizé kòmand-ou, vérsé on akont ou péman konplè :',
    'devisAccept.deposit50': 'Akont 50%',
    'devisAccept.fullPayment': 'Péman konplè',
    'devisAccept.alreadyAccepted': 'Devi-a té déja aksèpté.',
    'devisAccept.alreadyRefused': 'Devi-a té réfizé.',
    'devisAccept.statusMsg': 'Stati devi-a',
    'devisAccept.payDeposit': 'Péyé akont 50%',
    'devisAccept.homeRepairQuote': 'Devi réparasyon a domisil',
    'devisAccept.hello': 'Bonjo',
    'devisAccept.findBelow': 'Trouvé anba-a détay devi-ou :',
    'devisAccept.designation': 'Dézinyasyon',
    'devisAccept.travelFee': 'Fré déplasman',
    'devisAccept.tvaNote': 'TVA pa aplikab, art. 293B di CGI. Devi valab 30 jou.',
    'devisAccept.refuse': 'Réfizé',
    'devisAccept.accept': 'Aksèpté devi-a',
    'devisAccept.confirmRefuse': 'Ou sir ou vlé réfizé devi-a ?',
    // Payment
    'payment.secure': 'Péman sékirizé',
    'payment.error': 'Éré',
    'payment.backToDevis': 'Rétouné o devi',
    'payment.notAccepted': 'Devi pa aksèpté',
    'payment.mustAcceptFirst': 'Ou dwa aksèpté devi-a dabò avan péyé.',
    'payment.viewDevis': 'Wa devi-a',
    'payment.fullyPaid': 'Fakti antièman péyé',
    'payment.alreadyPaid': 'déja antièman péyé.',
    'payment.accessClient': 'Aksédé espas kliyant-ou',
    'payment.deposit50': 'Akont 50%',
    'payment.fullPayment': 'Péman konplè',
    'payment.devis': 'Devi',
    'payment.client': 'Kliyant',
    'payment.totalDevis': 'Total devi-a',
    'payment.alreadyPaidAmount': 'Déja péyé',
    'payment.remaining': 'Rès a péyé',
    'payment.depositPercent': 'Akont (50%)',
    'payment.amountToPay': 'Montan pou péyé',
    'payment.pay': 'Péyé',
    'payment.redirecting': 'Ka rédirijé vè Stripe...',
    'payment.securedBy': 'Péman sékirizé pa Stripe',
    'payment.urlNotAvailable': 'URL péman pa disponibl',
    'payment.creationError': 'Éré lò kréyasyon péman',
    // Payment success
    'paySuccess.confirmed': 'Péman konfirmé !',
    'paySuccess.paymentFor': 'Péman-ou pou devi',
    'paySuccess.registered': 'té anréjistré avèk siksè.',
    'paySuccess.depositRegistered': 'Akont anréjistré !',
    'paySuccess.depositFor': 'Akont-ou pou devi',
    'paySuccess.depositDone': 'té anréjistré.',
    'paySuccess.checking': 'Ka vérifié...',
    'paySuccess.pleaseWait': 'Nou ka vérifié péman-ou, atann souplé.',
    'paySuccess.waitingConfirm': 'Ka atann konfirmasyon',
    'paySuccess.processing': 'Péman-ou an kou d trètman. Ou ké résévwa on imèl konfirmasyon.',
    'paySuccess.totalInvoice': 'Total fakti',
    'paySuccess.amountPaid': 'Montan péyé',
    'paySuccess.remaining': 'Rès a péyé',
    'paySuccess.payRemaining': 'Péyé rès la',
    'paySuccess.loginClient': 'Konnèkté-ou a espas kliyant-ou',
    // Registration
    'register.clientTitle': 'Kréyé on kont kliyant',
    'register.fullName': 'Non konplè',
    'register.phone': 'Téléfòn',
    'register.email': 'Imèl (opsyonèl)',
    'register.address': 'Adrès (opsyonèl)',
    'register.pin': 'Kòd PIN (4 ou 6 chif)',
    'register.confirmPin': 'Konfirmé kòd PIN',
    'register.creating': 'Ka kréyé...',
    'register.createAccount': 'Kréyé kont-mwen',
    'register.alreadyAccount': 'Déja gen on kont ?',
    'register.login': 'Konnèkté',
    'register.backHome': 'Rétouné lakay',
    'register.pinError': 'Kòd PIN dwa gen 4 ou 6 chif',
    'register.pinNoMatch': 'Kòd PIN yo pa kòrèsponn',
    'register.pinMinLength': 'Kòd PIN dwa gen omoins 4 chif',
    // B2B Registration
    'b2bRegister.title': 'Enskripsyon Antréprize',
    'b2bRegister.subtitle': 'Kréyé kont pwofèsyonèl-ou',
    'b2bRegister.companyName': 'Non antréprize-a',
    'b2bRegister.managerName': 'Non jéran',
    'b2bRegister.proEmail': 'Imèl pwofèsyonèl',
    'b2bRegister.phone': 'Téléfòn',
    'b2bRegister.address': 'Adrès',
    'b2bRegister.siret': 'SIRET',
    'b2bRegister.password': 'Mo d pas',
    'b2bRegister.confirmPassword': 'Konfirmé mo d pas',
    'b2bRegister.kbis': 'Èkstrè KBIS (PDF)',
    'b2bRegister.kbisDesc': 'Téléchajé èkstrè KBIS-ou ou tout dokiman jistifikatif (PDF)',
    'b2bRegister.dropFile': 'Kliké ou dépozé fichié-ou isi',
    'b2bRegister.creating': 'Ka enskri...',
    'b2bRegister.submit': 'Enskri',
    'b2bRegister.success': 'Enskripsyon réyisi !',
    'b2bRegister.successMsg': 'Kont antréprize-ou an kou d validasyon. Ou ké résévwa on imèl konfirmasyon.',
    'b2bRegister.goLogin': 'Alé a konnèksyon',
    'b2bRegister.fillAll': 'Ranpli tout chan obligatwè souplé',
    'b2bRegister.siretError': 'SIRET dwa gen 14 chif',
    'b2bRegister.pwdNoMatch': 'Mo d pas yo pa kòrèsponn',
    'b2bRegister.pwdMinLength': 'Mo d pas dwa gen omoins 6 karaktè',
    'b2bRegister.kbisRequired': 'Téléchajé èkstrè KBIS-ou souplé',
    'b2bRegister.alreadyAccount': 'Déja enskri ?',
    // Reset password
    'reset.forgotTitle': 'Mo d pas bliyé',
    'reset.forgotDesc': 'Résévwa on lyèn réinisyalizasyon pa imèl',
    'reset.enterEmail': 'Tapé imèl-ou souplé',
    'reset.emailSent': 'Imèl voyé',
    'reset.emailSentMsg': 'Si on kont èksisté avèk adrès-a, ou ké résévwa on imèl avèk on lyèn pou réinisyalizé mo d pas-ou.',
    'reset.linkValid': 'Lyèn la valab pandan 1 è.',
    'reset.backLogin': 'Rétouné a konnèksyon',
    'reset.clientEmail': 'Adrès imèl kont-ou',
    'reset.sending': 'Ka voyé...',
    'reset.sendLink': 'Voyé lyèn réinisyalizasyon',
    'reset.newPwdTitle': 'Nouvo mo d pas',
    'reset.newPwdDesc': 'Chwazi nouvo mo d pas-ou',
    'reset.newPwd': 'Nouvo mo d pas',
    'reset.confirmPwd': 'Konfirmé mo d pas',
    'reset.resetting': 'Ka réinisyalizé...',
    'reset.resetPwd': 'Réinisyalizé mo d pas',
    'reset.pwdReset': 'Mo d pas réinisyalizé',
    'reset.pwdResetMsg': 'Mo d pas-ou chanjé avèk siksè.',
    'reset.pwdMinLength': 'Mo d pas dwa gen omoins 4 karaktè',
    'reset.pwdNoMatch': 'Mo d pas yo pa kòrèsponn',
    'reset.error': 'On éré rivé',
    // B2B Dashboard
    'b2b.welcome': 'Byenvini',
    'b2b.newRepair': 'Nouvo réparasyon',
    'b2b.registerDevice': 'Anréjistré on aparèy',
    'b2b.myRepairs': 'Réparasyon-mwen',
    'b2b.viewAll': 'Wa tout réparasyon',
    'b2b.recentRepairs': 'Dènié réparasyon',
    'b2b.noRepairs': 'Pa gen réparasyon',
    'b2b.repairRegistered': 'Réparasyon anréjistré',
    'b2b.reference': 'Référans',
    'b2b.viewDetails': 'Wa détay',
    'b2b.anotherRepair': 'Nouvo réparasyon',
    'b2b.deviceInfo': 'Enfòmasyon aparèy',
    'b2b.brand': 'Mak',
    'b2b.model': 'Modèl',
    'b2b.backGlass': 'Vit aryè',
    'b2b.backGlassBroken': 'Vit aryè kasé',
    'b2b.backGlassOk': 'Vit aryè entak',
    'b2b.providePart': 'Mo fourni pyès la',
    'b2b.partByShop': 'Pyès la ké fourni pa R.E.Mobiles',
    'b2b.lockCode': 'Kòd vérouaj',
    'b2b.lockTypeCode': 'Kòd (chif/lèt)',
    'b2b.lockTypeSchema': 'Skéma',
    'b2b.problem': 'Pwoblèm / Déskripsyon',
    'b2b.brokenParts': 'Pyès pa fonksyonè',
    'b2b.deliveryMethod': 'Mòd livrézon',
    'b2b.inStore': 'An boutik',
    'b2b.inStoreDesc': 'Dépozé o magazin',
    'b2b.postal': 'Anvwa postal',
    'b2b.postalDesc': 'Avèk niméro sivi',
    'b2b.pickup': 'Rékipérasyon',
    'b2b.pickupDesc': 'Nou ka vin chèché',
    'b2b.trackingNumber': 'Niméro sivi',
    'b2b.pickupAddress': 'Adrès rékipérasyon',
    'b2b.devicePhotos': 'Fòto aparèy la',
    'b2b.addPhotos': 'Kliké pou ajouté fòto',
    'b2b.additionalNotes': 'Nòt siplémanté',
    'b2b.submitting': 'Ka voyé...',
    'b2b.submitRepair': 'Anréjistré réparasyon',
    'b2b.brandModelRequired': 'Mak ak modèl obligatwè',
    'b2b.noRepairFound': 'Pa gen réparasyon trouvé',
    'b2b.allStatus': 'Tout',
    'b2b.documents': 'Dokiman & Fakti',
    'b2b.documentsDesc': 'Validé bon d kòmand-ou é téléchajé fakti-ou',
    'b2b.pendingValidation': 'Bon d kòmand pou validé',
    'b2b.enterCode': 'Tapé kòd ou résévwa pa imèl pou validé chak bon d kòmand.',
    'b2b.validate': 'Validé',
    'b2b.invoices': 'Fakti',
    'b2b.noInvoices': 'Pa gen fakti disponibl',
    'b2b.device': 'Aparèy',
    'b2b.amount': 'Montan',
    'b2b.date': 'Dat',
    'b2b.actions': 'Aksyon',
    'b2b.paid': 'Péyé',
    'b2b.repairAccepted': 'Réparasyon aksèpté pa staf la',
    'b2b.repairRefused': 'Réparasyon réfizé pa staf la',
    'b2b.orderValidated': 'Bon d kòmand validé',
    'b2b.noPhotos': 'Pa gen fòto',
    'b2b.history': 'Istorik',
    'b2b.repairPrice': 'Pri réparasyon',
    'b2b.diagPrice': 'Pri dyagnostik',
    'b2b.priceWaiting': 'An atant - ké fiksé pa R.E.Mobiles',
    'b2b.createdOn': 'Kréyé a',
    'b2b.clear': 'Éfasé',
    'b2b.thisMonth': 'Mwa-a',
    'b2b.waitingReception': 'Att. résèpsyon',
    'b2b.received': 'Résévwa',
    'b2b.inProgress': 'An kou',
    'b2b.waitingParts': 'Att. pyès',
    'b2b.completed': 'Tèminé',
    'b2b.delivered': 'Livré',
    // B2B Devis
    'b2bDevis.title': 'Devi Déplasman',
    'b2bDevis.pending': 'an atant',
    'b2bDevis.noDevis': 'Pa gen devi',
    'b2bDevis.noDevisDesc': 'Pa gen devi déplasman pou liminman.',
    'b2bDevis.travelFee': 'Fré déplasman',
    'b2bDevis.validationCode': 'Kòd validasyon',
    'b2bDevis.codeHint': 'Tapé kòd a 6 chif ou résévwa pa imèl.',
    'b2bDevis.acceptFirst': 'Aksèpté devi-a dabò pou pé validé-l.',
    'b2bDevis.payDeposit': 'Péyé akont 50%',
    'b2bDevis.payFull': 'Péyé total la',
    'b2bDevis.payRemaining': 'Péyé rès la',
    'b2bDevis.alreadyPaid': 'Déja péyé',
    'b2bDevis.remaining': 'Rès a péyé',
    'b2bDevis.invoiceDownload': 'Téléchajé fakti',
    'b2bDevis.orderDownload': 'Téléchajé bon d kòmand',
    'b2bDevis.quoteDownload': 'Téléchajé devi',
    // Admin Site Settings
    'adminSettings.title': 'Paj dakèy',
    'adminSettings.preview': 'Apèsi',
    'adminSettings.saving': 'Ka sovgardé...',
    'adminSettings.save': 'Sovgardé',
    'adminSettings.saved': 'Sovgardé !',
    'adminSettings.error': 'Éré',
    'adminSettings.heroSection': 'Antèt / Hero',
    'adminSettings.mainTitle': 'Tit prènsipal',
    'adminSettings.subtitle': 'Sou-tit',
    'adminSettings.accentColor': 'Koulè aksan (hex)',
    'adminSettings.bgImage': 'Imaj d fon',
    'adminSettings.change': 'Chanjé',
    'adminSettings.companyInfo': 'Enfòmasyon antréprize',
    'adminSettings.companyName': 'Non antréprize',
    'adminSettings.companyType': 'Tip (SAS, SARL...)',
    'adminSettings.capital': 'Kapital',
    'adminSettings.rcs': 'RCS',
    'adminSettings.siret': 'SIRET',
    'adminSettings.euid': 'EUID',
    'adminSettings.headquarters': 'Syèj sosyal',
    'adminSettings.salesPoint': 'Pwen d vant',
    'adminSettings.contactHours': 'Kontak & Orè',
    'adminSettings.phone': 'Téléfòn',
    'adminSettings.whatsapp': 'WhatsApp',
    'adminSettings.email': 'Imèl',
    'adminSettings.googleMaps': 'Google Maps query',
    'adminSettings.gallery': 'Galri fòto',
    'adminSettings.addImage': 'Ajouté on imaj',
    // Admin Database
    'adminDb.title': 'Administrasyon Baz Done',
    'adminDb.subtitle': 'Èkspò, enpò ak jésyon done',
    'adminDb.accessDenied': 'Aksè réfizé',
    'adminDb.adminOnly': 'Paj-a rézèrvé pou administratè',
    'adminDb.clients': 'Kliyant',
    'adminDb.users': 'Itilizatè',
    'adminDb.repairs': 'Réparasyon',
    'adminDb.stockArticles': 'Artik Stòk',
    'adminDb.exportTitle': 'Èkspò Baz Done',
    'adminDb.exportDesc': 'Èksporté tout done (kliyant, itilizatè, stòk, réparasyon, lavant) an fichié JSON.',
    'adminDb.exportConfirm': 'Èksporté tout baz done-a ?',
    'adminDb.exportBtn': 'Èksporté baz konplè',
    'adminDb.exportSuccess': 'Èkspò réyisi !',
    'adminDb.exportError': 'Éré lò èkspò',
    'adminDb.importTitle': 'Enpò Baz Done',
    'adminDb.importDesc': 'Enpòté on fichié JSON pou réstoré ou migré done.',
    'adminDb.fileSelected': 'Fichié séléksyoné',
    'adminDb.uploading': 'Ka upload fichié...',
    'adminDb.importDone': 'Enpò tèminé !',
    'adminDb.importSuccess': 'Enpò réyisi !',
    'adminDb.importError': 'Éré lò enpò',
    'adminDb.importClientsBtn': 'Enpòté Kliyant',
    'adminDb.importFullBtn': 'Enpò Konplè',
    'adminDb.importWarning': 'Enpò konplè ké ranplasé done ki èksisté',
    'adminDb.importConfirm': 'ATANSYON: Aksyon-a ké ranplasé done ki èksisté. Kontinié ?',
    'adminDb.importClientsConfirm': 'Enpòté kliyant yo ? Kont yo ké kréyé avèk niméro téléfòn kon idantifyan.',
    'adminDb.selectFile': 'Séléksyoné on fichié souplé',
    'adminDb.selectFileClients': 'Séléksyoné on fichié JSON avèk kliyant yo souplé',
    'adminDb.logsTitle': 'Jounal opérasyon',
    'adminDb.noLogs': 'Pa gen opérasyon anréjistré',
    // Admin B2B
    'adminB2b.title': 'Jésyon B2B',
    'adminB2b.home': 'Lakay',
    'adminB2b.monthlyRecap': 'Résimé Manswèl',
    'adminB2b.sending': 'Ka voyé...',
    'adminB2b.search': 'Chèché...',
    'adminB2b.recapTitle': 'Rézilta résimé manswèl',
    'adminB2b.recapSent': 'Voyé',
    'adminB2b.recapSkipped': 'Pa gen réparasyon',
    'adminB2b.recapError': 'Éré',
    'adminB2b.companies': 'Antréprize',
    'adminB2b.b2bRepairs': 'Réparasyon B2B',
    'adminB2b.paymentHistory': 'Istorik Péman',
    'adminB2b.all': 'Tout',
    'adminB2b.pending': 'An atant',
    'adminB2b.validated': 'Validé',
    'adminB2b.refused': 'Réfizé',
    'adminB2b.suspended': 'Sispann',
    'adminB2b.noCompany': 'Pa gen antréprize trouvé',
    'adminB2b.phone': 'Téléfòn',
    'adminB2b.siret': 'SIRET',
    'adminB2b.address': 'Adrès',
    'adminB2b.registeredOn': 'Enskri a',
    'adminB2b.validatedBy': 'Validé pa',
    'adminB2b.downloadKbis': 'Téléchajé KBIS',
    'adminB2b.validate': 'Validé',
    'adminB2b.refuse': 'Réfizé',
    'adminB2b.suspend': 'Sispann',
    'adminB2b.confirmValidate': 'Ou vlé validé antréprize-a ?',
    'adminB2b.confirmRefuse': 'Ou vlé réfizé antréprize-a ?',
    'adminB2b.confirmSuspend': 'Ou vlé sispann antréprize-a ?',
    'adminB2b.pendingReception': 'An atant résèpsyon',
    'adminB2b.confirmReception': 'Konfirmé résèpsyon',
    'adminB2b.ref': 'Réf',
    'adminB2b.company': 'Antréprize',
    'adminB2b.brandModel': 'Mak / Modèl',
    'adminB2b.problem': 'Pwoblèm',
    'adminB2b.delivery': 'Livrézon',
    'adminB2b.price': 'Pri',
    'adminB2b.status': 'Stati',
    'adminB2b.actions': 'Aksyon',
    'adminB2b.noRepairs': 'Pa gen réparasyon B2B trouvé',
    'adminB2b.postal': 'Postal',
    'adminB2b.pickup': 'Rékip.',
    'adminB2b.inStore': 'Boutik',
    'adminB2b.changeStatus': 'Chanjé stati',
    'adminB2b.setPrice': 'Fiksé pri',
    'adminB2b.repairPrice': 'Pri réparasyon',
    'adminB2b.diagPrice': 'Pri dyagnostik',
    'adminB2b.locked': 'Véroyé (péyé)',
    'adminB2b.total': 'Total',
    'adminB2b.existingInvoices': 'Fakti ki èksisté',
    'adminB2b.diagnostic': 'Dyagnostik',
    'adminB2b.repair': 'Réparasyon',
    'adminB2b.combined': 'Konbiné',
    'adminB2b.paidMethod': 'Péyé',
    'adminB2b.awaitingPayment': 'An atant',
    'adminB2b.markPaid': 'Péyé',
    'adminB2b.finalize': 'Finalizé faktrasyon',
    'adminB2b.backGlassBroken': 'Vit ary. kasé',
    'adminB2b.clientPart': 'Pyès kliyant',
    'adminB2b.bcValidated': 'BK validé',
    'adminB2b.invoiceCancelled': 'Fakti anilé',
    'adminB2b.monthPrompt': 'Mwa (1-12) ? Kit vid pou mwa avan :',
    'adminB2b.yearPrompt': 'Lané ?',
    'adminB2b.paymentMethodPrompt': 'Mòd péman ?',
    'adminB2b.filterCompany': 'Antréprize',
    'adminB2b.filterDateStart': 'Dat kòmansman',
    'adminB2b.filterDateEnd': 'Dat fen',
    'adminB2b.filter': 'Filtré',
    'adminB2b.clearFilter': 'Éfasé',
    'adminB2b.totalCollected': 'Total ankèsé',
    'adminB2b.payments': 'péman',
    'adminB2b.payHistoryTitle': 'Istorik péman B2B',
    'adminB2b.noPayments': 'Pa gen péman B2B anréjistré',
    'adminB2b.invoice': 'Fakti',
    // Users Management
    'users.title': 'Jésyon itilizatè',
    'users.count': 'itilizatè',
    'users.new': 'Nouvo itilizatè',
    'users.edit': 'Modifyé itilizatè',
    'users.username': 'Non itilizatè',
    'users.password': 'Mo d pas',
    'users.newPassword': 'Nouvo mo d pas (kit vid pou pa chanjé)',
    'users.role': 'Ròl',
    'users.roleAdmin': 'Administratè',
    'users.roleUser': 'Komèrsyal',
    'users.roleTech': 'Téchnisyen',
    'users.status': 'Stati',
    'users.active': 'Aktif',
    'users.inactive': 'Inaktif',
    'users.createdAt': 'Kréyé a',
    'users.noUsers': 'Pa gen itilizatè',
    'users.accessDenied': 'Aksè rézèrvé pou administratè',
    'users.deleteConfirm': 'Siprimé itilizatè-a ?',
    // Stats
    'stats.title': 'Statistik & Analitik',
    'stats.revenue': 'Chif d afè',
    'stats.repairs': 'Réparasyon',
    'stats.b2b': 'B2B',
    'stats.clients': 'Kliyant',
    'stats.back': 'Rétouné',
    'stats.monthlyRevenue': 'CA Manswèl',
    'stats.revenueByType': 'CA pa tip',
    'stats.revenueByPayment': 'CA pa mòd péman',
    'stats.totalRevenue': 'CA Total (12 mwa)',
    'stats.repairsByStatus': 'Pa stati',
    'stats.repairsByBrand': 'Pa mak',
    'stats.topModels': 'Tòp modèl',
    'stats.monthly': 'Évolisyon manswèl',
    'stats.totalRepairs': 'Total réparasyon',
    'stats.avgRepairTime': 'Diré mwayèn',
    'stats.completionRate': 'To achèvman',
    'stats.b2bCompanies': 'Antréprize B2B',
    'stats.b2bRepairs': 'Réparasyon B2B',
    'stats.b2bRevenue': 'CA B2B',
    'stats.b2bByCompany': 'Pa antréprize',
    'stats.totalClients': 'Total kliyant',
    'stats.newThisMonth': 'Nouvo mwa-a',
    'stats.withAccount': 'Avèk kont',
    'stats.clientsByType': 'Pa tip',
    'stats.registrations': 'Enskripsyon manswèl',
    'stats.noData': 'Pa gen done',
    // Historique
    'hist.title': 'Istorik lavant',
    'hist.search': 'Chèché on lavant...',
    'hist.noSales': 'Pa gen lavant trouvé',
    'hist.ref': 'Réf.',
    'hist.client': 'Kliyant',
    'hist.amount': 'Montan',
    'hist.payment': 'Péman',
    'hist.date': 'Dat',
    'hist.articles': 'Artik',
    'hist.refund': 'Ranbousé',
    'hist.refundConfirm': 'Ranbousé lavant-a ?',
    // Paiements
    'pay.title': 'Péman an lign',
    'pay.search': 'Chèché...',
    'pay.noPayments': 'Pa gen péman trouvé',
    'pay.ref': 'Référans',
    'pay.client': 'Kliyant',
    'pay.amount': 'Montan',
    'pay.status': 'Stati',
    'pay.date': 'Dat',
    'pay.type': 'Tip',
    // Caisse
    'caisse.title': 'Istorik Kès',
    'caisse.noCaisse': 'Pa gen kès trouvé',
    'caisse.openedBy': 'Ouvè pa',
    'caisse.openingAmount': 'Montan louvèti',
    'caisse.closingAmount': 'Montan fèmti',
    'caisse.sales': 'Lavant',
    'caisse.openDate': 'Louvèti',
    'caisse.closeDate': 'Fèmti',
    // Notes
    'notes.title': 'Nòt',
    'notes.new': 'Nouvo nòt',
    'notes.noNotes': 'Pa gen nòt',
    'notes.deleteConfirm': 'Siprimé nòt-a ?',
    // Etiquettes
    'labels.title': 'Étikèt',
    'labels.search': 'Chèché...',
    'labels.print': 'Enprimé',
    'labels.selectAll': 'Séléksyoné tout',
    'labels.noLabels': 'Pa gen étikèt',
    // Calcul Prix
    'calc.title': 'Kalkil Pri',
    'calc.searchDevice': 'Chèché on aparèy...',
    'calc.selectRepair': 'Séléksyoné on réparasyon',
    'calc.generateQuote': 'Jénéré on devi',
    'calc.generateInvoice': 'Jénéré on fakti',
    // Boutique
    'boutique.title': 'Kòmand Boutik',
    'boutique.noOrders': 'Pa gen kòmand',
    'boutique.orderRef': 'Réf. kòmand',
    'boutique.clientName': 'Kliyant',
    'boutique.total': 'Total',
    'boutique.status': 'Stati',
    // Chat
    'chat.title': 'Mésajri',
    'chat.noConversations': 'Pa gen konvèsasyon',
    'chat.typeMessage': 'Tapé mésaj-ou...',
    // Brands & Models
    'brands.title': 'Mak & Modèl',
    'brands.addBrand': 'Ajouté on mak',
    'brands.addModel': 'Ajouté on modèl',
    'brands.noBrands': 'Pa gen mak',
    'brands.deleteConfirm': 'Siprimé mak-a ?',
    // Remcaches
    'remcaches.title': 'Rémiz an Kach',
    'remcaches.noItems': 'Pa gen artik',
    // Close Caisse
    'closeCaisse.title': 'Fèmti d Kès',
    'closeCaisse.countCoins': 'Kontaj lajan kach',
    'closeCaisse.theoreticalTotal': 'Total téorik',
    'closeCaisse.actualTotal': 'Total réyèl',
    'closeCaisse.difference': 'Éka',
    'closeCaisse.close': 'Fèmé kès la',
    'closeCaisse.closing': 'Ka fèmé...',
    // Client Passwords
    'clientPwd.title': 'Mo d Pas Kliyant',
    'clientPwd.search': 'Chèché on kliyant...',
    'clientPwd.noClients': 'Pa gen kliyant trouvé',
    'clientPwd.generatePin': 'Jénéré PIN',
    'clientPwd.sendByEmail': 'Voyé pa imèl',
    // B2B Payments
    'b2bPay.title': 'Péman B2B',
    'b2bPay.noPayments': 'Pa gen péman',
    // Reparation Form
    'repForm.title': 'Ajouté on aparèy',
    'repForm.editTitle': 'Modifyé réparasyon',
    'repForm.brand': 'Mak',
    'repForm.model': 'Modèl',
    'repForm.imei': 'IMEI / N° séri',
    'repForm.lockCode': 'Kòd vérouaj',
    'repForm.problem': 'Pwoblèm konstaté',
    'repForm.client': 'Kliyant',
    'repForm.technician': 'Téchnisyen asinyé',
    'repForm.price': 'Pri réparasyon',
    'repForm.submit': 'Anréjistré',
    'repForm.submitting': 'Ka anréjistré...',
    // SumUp payment link
    'sumup.acceptOnlinePayment': 'Aksèpté péman an lign (SumUp)',
    'sumup.acceptOnlinePaymentDesc': 'Kliyant la ké pé dmandé on lyèn péman SumUp',
    'sumup.requestLink': 'Dmandé lyèn péman SumUp',
    'sumup.requestSent': 'Dmand voyé ! Ou ké résévwa lyèn la pa imèl byento.',
    'sumup.alreadyRequested': 'Dmand déja an kou.',
    'sumup.onlinePayment': 'Péman an lign SumUp',
    'sumup.receiveLink': 'Résévwa on lyèn péman sékirizé pa imèl',
    'sumup.linkRequested': 'Lyèn dmandé',
    'sumup.pendingRequests': 'Dmand lyèn SumUp',
    'sumup.pending': 'an atant',
    'sumup.pasteLinkHere': 'Kolé lyèn SumUp isi...',
    'sumup.send': 'Voyé',
    'sumup.linkSent': 'Lyèn SumUp voyé ba kliyant pa imèl !',
};

export default gcr;
